import script from "./AIOrderTaskWindow.vue?vue&type=script&lang=tsx&setup=true"
export * from "./AIOrderTaskWindow.vue?vue&type=script&lang=tsx&setup=true"

import "./AIOrderTaskWindow.vue?vue&type=style&index=0&id=bafea808&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bafea808"]])

export default __exports__